import type { Address } from 'viem'

import { ChainId } from '@morpho-org/blue-sdk'

export interface DeprecatedVault {
  address: Address
  chainId: ChainId
  name: string
  /**
   * Smallest redeemable amount, in the vault's asset units, that counts as a real
   * position: a cent or two, in the spirit of `DUST_FLOOR_USD` (see `helpers/dust.ts`).
   * Below it, the shares a full withdraw leaves behind would keep prompting the user.
   */
  minAssets: bigint
}

/**
 * Vaults whose depositors get an undismissable withdrawal prompt (see `StatusToasts`).
 *
 * The Seamless USDC vault's reported assets exceed what it actually holds after
 * `lostAssets` was booked, overstating its share price, so depositors are still prompted
 * to exit before withdrawals drain what is left.
 * Delete this file and `useDeprecatedVaultPositions` once the USDC vault holds no user
 * deposits; nothing else will surface it, so check share supply before assuming it is
 * still needed.
 */
export const DEPRECATED_VAULTS: readonly DeprecatedVault[] = [
  {
    address: '0x616a4E1db48e22028f6bbf20444Cd3b8e3273738',
    chainId: ChainId.BaseMainnet,
    name: 'Seamless USDC Vault',
    minAssets: 10_000n // 0.01 USDC, 6 decimals
  }
]
